const CUSTOM_THEME_STYLE_TYPE = "custom-css";
const ORG_THEME_STYLE_TYPE = "org-theme";
const RUNTIME_THEME_STYLE_TYPES = [
  ORG_THEME_STYLE_TYPE,
  CUSTOM_THEME_STYLE_TYPE,
] as const;

const API_THEME_LINK_SELECTOR = "link[data-theme-source='api']";

interface IApplyRuntimeBrandingCssProps {
  cssContent: string;
  styleType: (typeof RUNTIME_THEME_STYLE_TYPES)[number];
}

export const clearRuntimeBrandingCss = (): void => {
  document.querySelector(API_THEME_LINK_SELECTOR)?.remove();

  clearRuntimeBrandingStyleTags();
};

export const clearRuntimeBrandingStyleTags = (): void => {
  for (const styleType of RUNTIME_THEME_STYLE_TYPES) {
    const existingTags = document.querySelectorAll(
      `[data-style-type='${styleType}']`,
    );

    for (const styleElement of existingTags) {
      styleElement.remove();
    }
  }
};

const applyRuntimeBrandingCss = ({
  cssContent,
  styleType,
}: IApplyRuntimeBrandingCssProps): void => {
  clearRuntimeBrandingCss();

  if (!cssContent) {
    return;
  }

  const styleTag = document.createElement("style");
  styleTag.textContent = cssContent;
  styleTag.dataset.styleType = styleType;
  document.head.appendChild(styleTag);
};

export const applyOrgThemeCss = (cssContent: string): void => {
  applyRuntimeBrandingCss({
    cssContent,
    styleType: ORG_THEME_STYLE_TYPE,
  });
};

export const applyCustomThemeCss = (cssContent: string): void => {
  applyRuntimeBrandingCss({
    cssContent,
    styleType: CUSTOM_THEME_STYLE_TYPE,
  });
};
